import { Box } from "@chakra-ui/react";
import { ColorIcon, customEvent } from "goi_common";
import { BaseStack, baseColors } from "goi_common/src/design-system";

/** E5 화면 맨 위 뒤로 가기. 질문이 한 장이라 진행 막대는 두지 않는다 */
export default function QuestionTopBar({ onBack }: { onBack: () => void }) {
  return (
    <BaseStack direction="horizontal" width="100%" px="20px" pt="16px" alignItems="center">
      <Box
        as="button"
        type="button"
        aria-label="이전"
        cursor="pointer"
        display="flex"
        // 아이콘 안쪽 여백만큼 왼쪽으로 붙인다(여백 대신 위치 이동)
        transform="translateX(-6px)"
        onClick={() => {
          customEvent({ newGtm: { path: "parlor_match_request", trigger_and_target: "e5_back" } });
          onBack();
        }}
      >
        <ColorIcon name="arrow_left_small" size={28} color={baseColors.label_normal} />
      </Box>
    </BaseStack>
  );
}
